module.exports = __webpack_public_path__ + "media/images/flags/nu-62d2f1f712a04ceee5cefa2977a93e04.svg";